import React, { useState, useMemo } from "react";
import { Toast } from "./../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams, useLocation, useHistory } from "react-router";
import CreateCommonCostsForm from "./CreateCommonCostsForm";
import { fetchProviders } from "../../helpers/api/provider";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import { fetchCreateCommonCost } from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { fetchProperties } from "../../helpers/api/condominium";
import { formatDate } from "../../helpers/utils";
import { format } from "prettier";
import moment from "moment";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreateCommonCosts = ({ setRedirectUrl, setRedirect }) => {
  const moduleBase = useModuleBase();

  const { id } = useParams();

  const { selectedCondominium } = useSelector((state) => state.condominium);
  const params = useMemo(() => ({
    condominiumId: id || selectedCondominium,
  }), [id, selectedCondominium]);
  const { state } = useLocation();
  const history = useHistory();

  const {
    mutate,
    data,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchProviders, params);

  const properties = useSWRFetchPagination(fetchProperties, params);
  console.log(properties);


  const create = async (values) => {
    if (!state?.type_id) {
      return Toast.fire({
        type: "error",
        title: "No se ha podido crear el tipo de gasto comun",
      });
    }

    if (!values.provider_id && !values.provider_name) {
      return Toast.fire({
        type: "error",
        title: "Debes seleccionar un proveedor frecuente o ingresar los datos de un proveedor no frecuente.",
      });
    }

    console.log(values);
    try {
      const { code } = await fetchCreateCommonCost(
        id || selectedCondominium,
        {
          ...values,
          // La tasa la decide el formulario según la fecha del gasto. Si no
          // pudo resolverla va vacía y la completa el backend: mandar la del
          // día (activeExchangeRate) guardaría una tasa que no es la del gasto.
          rate: values.rate || null,
          type_id: state.type_id,
        }
      );
      if (code === SUCCESS_RESPONSE.OK) {
        history.push({
          pathname: `/dashboard/${moduleBase}/${id}/common-costs`,
          state: {
            type_id: state.type_id,
            type_name: state.type_name,
          },
        });

        /*       setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-costs`);
          setRedirect(true); */
        /*     setRedirectUrl(`/dashboard/${moduleBase}/${id}/common-costs`);
        setRedirect(true); */
        Toast.fire({
          type: "success",
          title: `Gasto común registrado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  return (
    <>
      <PageHeader
        title={state?.type_name || "Crear Gasto"}
        titleTag="h2"
        description="Asigna un gasto comun a un proveedor."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <PreloadState loading={isLoading}>
        <CreateCommonCostsForm
          handleSubmitData={create}
          mutate={mutate}
          handler={{ nextPage, previousPage, perPage, goToPage, meta }}
          /*    handlerN={properties.nextPage}
             handlerP={properties.previousPage}
             handlerPP={properties.perPage}
             handlerGP={properties.goToPage}
             handlerMeta={properties.meta} */
          handlerM={properties.handler}
          providers={data}
          metaa={properties.meta}
          properties={properties.data}
        />
      </PreloadState>
    </>
  );
};

export default withRedirect(CreateCommonCosts);
